export enum EThemeContextOptions {
    FIRE = 'FIRE',
    WATER = 'WATER',
    DRAGON = 'DRAGON'
}
